import { Injectable } from "@angular/core";
import { Selector, State } from "@ngxs/store";
import { INgxsFormState } from "../../model/custom/INgxsFormState";

export class IncidentReportingFormStateModel {
	public form: INgxsFormState;
}

@State<IncidentReportingFormStateModel>({
	name: "incidentReportingForm",
	defaults: {
		form: {
			model: null,
			dirty: false,
			status: "",
			errors: null,
		},
	},
})
@Injectable()
export class IncidentReportingFormState {
	@Selector()
	static form(state: IncidentReportingFormStateModel) {
		return state.form;
	}
}
